import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [],
        name: ''
      }
    },
    {
      path: '/home',
      name: 'home',
      // beforeEnter
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Inicio' }],
        name: 'Sistema de Integral de Gestion de Servicios'
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/home.view.vue')
    },

    {
      path: '/Formulario',
      name: 'video',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Form' }
        ]
      },
      component: () => import('./views/ejemplos/form.view.vue')
    },
    {
      path: '/Table',
      name: 'table',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Table' }
        ]
      },
      component: () => import('./views/ejemplos/table.view.vue')
    },
    {
      path: '/Importador',
      name: 'importador',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Importador' }
        ]
      },
      component: () => import('./views/ejemplos/importador.view.vue')
    },
    {
      path: '/Menu',
      name: 'menu',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Menu Dinamico' }
        ]
      },
      component: () => import('./views/ejemplos/MenuDinamic.view.vue')
    },

    // Mesa de ayuda \\
    {
      path: '/MesaAyuda/Solicitudes',
      name: 'MeAyuSolicitudes',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Mesa Ayuda' },
          { name: 'Solicitudes' }
        ],
        name: 'Solicitudes'
      },
      component: () => import('./views/mesaAyuda/solicitudes.view.vue')
    },
    {
      path: '/MesaAyuda/Calendario',
      name: 'MeAyuCalendar',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Mesa Ayuda' },
          { name: 'Calendario' }
        ],
        name: 'Calendario de Actividades'
      },
      component: () => import('./views/mesaAyuda/calendarSolicitudes.view.vue')
    },
    {
      path: '/MesaAyuda/Servicios',
      name: 'MeAyuServicio',
      meta: {
        allowAnonymous: true,
        name: 'Servicios',
        breadcrumb: [
          { name: 'Mesa Ayuda' },
          { name: 'Servicios' }
        ]
      },
      component: () => import('./views/mesaAyuda/servicios.view.vue')
    },
    // Fin Mesa de ayuda Fin \\

    // Catalogos \\
    // *===* Catalogos  Accesos *===* \\
    {
      path: '/Catalogo/Empleados',
      name: 'ViewEmpleados',
      meta: {
        allowAnonymous: true,
        name: 'Empleados',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Empleados' }
        ]
      },
      component: () => import('./views/company/empleados.view.vue')
    },
    {
      path: '/Catalogo/Usuarios',
      name: 'ViewUsuarios',
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'usuarios' }
        ]
      },
      component: () => import('./views/company/usuarios.view.vue')
    },
    {
      path: '/Catalogo/Roles',
      name: 'ViewRols',
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Roles' }
        ]
      },
      component: () => import('./views/company/roles.view.vue')
    },
    {
      path: '/Catalogo/Permisos',
      name: 'ViewPermisos',
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/company/permisos.view.vue')
    },
    {
      path: '/Catalogo/Roles/Permisos/:id',
      name: 'ViewPermissionsRoleAssign',
      meta: {
        allowAnonymous: true,
        name: 'Asignar Permisos a Rol',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Roles' },
          { name: 'Asignacion de Permisos' }
        ]
      },
      component: () => import('./views/company/rolePermissionsAssign.view.vue')
    },
    {
      path: '/Empresa/Departamentos',
      name: 'departamentos',
      meta: {
        allowAnonymous: true,
        name: 'Departamentos',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'Departamentos' }
        ]
      },
      component: () => import('./views/company/departamentos.view.vue')
    },
    // *===* Fin Catalogos Accesos Fin *===* \\

    // *===* Catalogos  Inventarios *===* \\
    {
      path: '/Inventario/Insumos',
      name: 'InvInsumos',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Insumos' }
        ],
        name: 'Insumos'
      },
      component: () => import('./views/insumo/insumos.view.vue')
    },
    {
      path: '/Inventario/Equipos/Almacen',
      name: 'InvEquipos',
      meta: {
        allowAnonymous: true,
        name: 'Equipos',
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Equipos' }
        ]
      },
      component: () => import('./views/equipos/equipos.view.vue')
    },
    // *===* Fin Catalogos  Inventarios Fin *===* \\

    // *===* Catalogos  Configuraciones *===* \\
    {
      path: '/Configuraciones/Caracteristicas',
      name: 'InvCaracteristicas',
      meta: {
        allowAnonymous: true,
        name: 'Caracteristicas',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Caracteristicas' }
        ]
      },
      component: () => import('./views/inventarios/caracteristicas.view.vue')
    },
    {
      path: '/Configuraciones/TipoDato',
      name: 'InvTipoDato',
      meta: {
        allowAnonymous: true,
        name: 'Tipo de Dato',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Tipo de Dato' }
        ]
      },
      component: () => import('./views/inventarios/tipoDato.view.vue')
    },
    {
      path: '/Configuraciones/Familias',
      name: 'InvFamilia',
      meta: {
        allowAnonymous: true,
        name: 'Familias',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Familia' }
        ]
      },
      component: () => import('./views/inventarios/familias.view.vue')
    },
    {
      path: '/Configuraciones/Marcas',
      name: 'InvMarcas',
      meta: {
        allowAnonymous: true,
        name: 'Marcas',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Marca' }
        ]
      },
      component: () => import('./views/inventarios/marcas.view.vue')
    },
    {
      path: '/Catalogo/Procedencias',
      name: 'InvProcedencias',
      meta: {
        allowAnonymous: true,
        name: 'Procedencias',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Procedencias' }
        ]
      },
      component: () => import('./views/inventarios/procedencias.view')
    },
    {
      path: '/Inventarios/Proveedores',
      name: 'InvProveedores',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Proveedores' }
        ]
      },
      component: () => import('./views/inventarios/proveedores.view.vue')
    },
    {
      path: '/Inventarios/Importador',
      name: 'InvImportador',
      meta: {
        allowAnonymous: true,
        name: 'Importador',
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Importador' }
        ]
      },
      component: () => import('./views/inventarios/importadorMain.view.vue')
    },
    {
      path: '/Configuraciones/Test-Email',
      name: 'InvTestEmial',
      meta: {
        allowAnonymous: true,
        name: 'Test Email',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Test Email' }
        ]
      },
      component: () => import('./views/inventarios/testemail.view.vue')
    },
    // *===* Fin Catalogos  Configuraciones Fin *===* \\
    // Fin Catalogos Fin \\

    // Almacen Insumos \\
    {
      path: '/Inventario/Insumos/Almacen',
      name: 'InvInsumoAlmacen',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Inventarios' },
          { name: 'Insumos' }
        ],
        name: 'Almacen Insumos'
      },
      component: () => import('./views/insumo/almacen.view.vue')
    },
    // Fin Almacen Insumos Fin \\

    // Configuraciones \\
    {
      path: '/Configuraciones/TiposProcesos',
      name: 'ViewProcesos',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Procesos',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Tipos de Procesos' }
        ]
      },
      component: () => import('./views/company/configuraciones/procesos.view.vue')
    }
    // Fin Configuraciones Fin \\
  ]
})
